// Eigenbau: Gemeinsamer Nachladeabschluss für serverseitige Cursorlisten.
import { Button } from "@/components/Button";

/** Gemeinsamer Abschluss einer serverseitig cursorpaginierten Liste. */
export function MehrLaden({
  hatMehr,
  laedt,
  laden,
  beschriftung = "Weitere laden",
  className,
}: {
  hatMehr: boolean;
  laedt: boolean;
  laden: () => void;
  beschriftung?: string;
  className?: string;
}) {
  if (!hatMehr) return null;
  return (
    <div className={className ?? "mt-4"}>
      <Button variant="secondary" disabled={laedt} onClick={laden}>
        {laedt ? "Lade …" : beschriftung}
      </Button>
    </div>
  );
}
